import { formatUSD } from '../../../helpers';
import PoolSummaryHeader from '../PoolSummaryHeader';
import TotalDeposits from './TotalDeposits';
// import useUserTotalDeposits from '../../../hooks/web3/pools/useUserTotalDeposits';
import useMockUserTotalDeposits from '../../../hooks/web3/pools/useMockUserTotalDeposits';
import useUserPoolPnl from '../../../hooks/web3/pools/useUserPoolPnl';

const PoolTotalDeposits = () => {
    // const { userTotalDeposits } = useUserTotalDeposits();
    const { userTotalDeposits } = useMockUserTotalDeposits();

    const { userPoolPnl } = useUserPoolPnl();

    return userTotalDeposits ? (
        <div className='pool-total-deposits-container'>
            <PoolSummaryHeader
                title='Historical Deposits'
                value={formatUSD(userTotalDeposits.totalDepositAssetAllPools, {
                    minDecimals: 2,
                })}
            />
            <div className='total-deposits-container'>
                {userTotalDeposits.totalDepositsPerPool
                    .sort(
                        (a, b) =>
                            a.liquidityPool.displayOrder - b.liquidityPool.displayOrder
                    )
                    .map((userLockUp, index) => {
                        const pnlPerPool = userPoolPnl?.userPoolPnl.find(
                            ({ liquidityPool: lockedPool }) =>
                                lockedPool.poolId.toLowerCase() ===
                                userLockUp.liquidityPool.poolId.toLowerCase()
                        );

                        return (
                            <TotalDeposits
                                lockPoolDetails={{
                                    ...userLockUp,
                                    pnl: pnlPerPool ? pnlPerPool.pnlPerPool : '0',
                                    pnlPercent: pnlPerPool
                                        ? pnlPerPool.pnlPercentagePerPool
                                        : '0',
                                }}
                                key={index}
                            />
                        );
                    })}
            </div>
        </div>
    ) : null;
};

export default PoolTotalDeposits;
